var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.60966 5.86016C8.24522 6.40538 7.563 6.67798 7.48069 7.24324C7.39837 7.80849 7.97047 8.29204 9.11468 9.25915L9.4107 9.50935C9.73584 9.78417 9.89842 9.92158 9.99161 10.1089C10.0848 10.2962 10.0981 10.5121 10.1246 10.9441L10.1488 11.3373C10.2421 12.8574 10.2888 13.6174 10.7828 13.8794C11.2768 14.1414 11.8909 13.7319 13.1191 12.9129L13.4368 12.701C13.7858 12.4683 13.9603 12.3519 14.1599 12.32C14.3595 12.288 14.5616 12.344 14.9657 12.456L15.3336 12.558C16.7558 12.9522 17.4669 13.1493 17.8545 12.746C18.2421 12.3427 18.0495 11.6061 17.6644 10.1328M17.999 7.83522C18.7845 6.55883 19.1773 5.92063 18.9229 5.40935C18.6685 4.89806 17.9354 4.85229 16.4691 4.76076L16.0898 4.73708C15.6731 4.71107 15.4648 4.69807 15.2839 4.60208C15.1029 4.5061 14.9698 4.338 14.7037 4.00181L14.4614 3.69574C13.5247 2.51266 13.0564 1.92112 12.5115 2.00845C11.9667 2.09577 11.7062 2.80412 11.1851 4.22083",
    stroke: "#8766ff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44645 7.24121C5.11144 8.94915 3.32371 12.2158 4.24844 18.0004C5.06701 15.5892 7.53446 13.6579 10.2908 12.7283",
    stroke: "#8766ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2808 16C10.2808 16 10.9135 17.3908 11.6935 17.8692C12.4735 18.3475 14 18.2808 14 18.2808C14 18.2808 12.6092 18.9135 12.1308 19.6935C11.6525 20.4735 11.7192 22 11.7192 22C11.7192 22 11.0865 20.6092 10.3065 20.1308C9.52652 19.6525 8 19.7192 8 19.7192C8 19.7192 9.39082 19.0865 9.86916 18.3065C10.3475 17.5265 10.2808 16 10.2808 16Z",
    stroke: "#8766ff",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4795 15C18.4795 15 18.0577 15.9272 17.5377 16.2461C17.0177 16.565 16 16.5205 16 16.5205C16 16.5205 16.9272 16.9423 17.2461 17.4623C17.565 17.9823 17.5205 19 17.5205 19C17.5205 19 17.9423 18.0728 18.4623 17.7539C18.9823 17.435 20 17.4795 20 17.4795C20 17.4795 19.0728 17.0577 18.7539 16.5377C18.435 16.0177 18.4795 15 18.4795 15Z",
    stroke: "#8766ff",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ebb3caefe01617d8756d85f75095d4e5.svg";
export { ForwardRef as ReactComponent };